export class QcReportDetailDTO {
    _id: string;
    dateAndTime: Date;
    plateName: string;
    plateQCStatus: PlateQCStatusList;
    qcParams: EurofinsControlParamsDTO[];
    contiguousReadLengthAvg: number;
    contiguousReadLengthMax: number;
    contiguousReadLengthMin: number;
    contiguousBaseCutOff: number;
    baseCallStartRange: string;
    avgSignalIntensityRange: string;
    baseCallStartFailedNumber: number;
    baseCallStartFailedPercentage: number;
    dyeBlobsFailedNumber: number;
    dyeBlobsFailedPercentage: number;
    contiguousReadsFailedNumber: number;
    contiguousReadsFailedPercentage: number;
    avgSignalIntensityFailedNumber: number;
    avgSignalIntensityFailedPercentage: number;
    mixedSeqFailedNumber: number;
    mixedSeqFailedPercentage: number;
    missingSeqFailedNumber: number;
    missingSeqFailedPercentage: number;
    numberFiles: number;
    numberFilesEmpty: number;
    numberFilesUsed: number;
    action: string;

    reportIdentifier: string;

    labIdentifier: string;

    approvalDate: string;

    approvalTime: string;

    approvedBy: string;

    plateQCComment: string;

    approvalMessageLocation: string;
    
    reportType:string;

    mapOfPositionAndReportDetails: any;
}
export interface EurofinsControlParamsDTO {
    readIdentifier: string;
    status: string;
    usedPrimer: string;
    guessPrimer: string;
    referenceName: string;
    lengthOfControl: string;
    positionsOnReference: string;
}
export enum PlateQCStatusList {
    OK,
    NOQC,
    QCFAILED,
    FAILED,
    TRASH
}

